import React, { useEffect, useState } from 'react';
import { Container, Col, Row, Modal, Table, Button, Card, Form } from 'react-bootstrap';
import styles from './ExtendAssessmentTimeModal.module.scss';
import { Formik } from 'formik';
import { CustomTextField } from '../../../../../../shared/customTextField';
import { CustomButton } from '../../../../../../shared/customButton';
import * as yup from 'yup';
import { CustomAlertBox } from '../../../../../../shared/customAlertBox';
import { extendAssessmentTime } from '../../../../../../../services/util/hiringpipeline/candidates';

const ExtendAssessmentTimeModal = (props) => {

    const [step, setStep] = useState(1);
    const [extendingTime, setExtendingTime] = useState(0);
    const [newDeadline, setNewDeadline] = useState();
    const [isLoading, setLoading] = useState(false);

    let moment = require('moment-timezone');

    const schema = yup.object({
        noOfExtendingDates: yup.number('quiz expire date should be a Number').required('Required').integer('Invalid input').moreThan(0, 'Invalid input'),
    })

    const onSubmit = async (values) => {
        setLoading(true)
        let response = await extendAssessmentTime(props.assessmentData.external_assessment_session_id, extendingTime);
        if (response.success === true) {

            props.modalClose();
            props.getCandidateAllDetails();
            setLoading(false);
        } else {
            setLoading(false)
        }
    }

    const nextPage = (values) => {
        setExtendingTime(values.noOfExtendingDates)
        setStep(2);
    }

    const NewDeadline = () => {
        let new_deadline = moment(props.assessmentData.to_be_expired_at).add(extendingTime, 'days');
        setNewDeadline(new_deadline);
    }

    useEffect(() => {
        NewDeadline();
    }, [extendingTime])


    return (
        <Modal
            show={props.showDetailsModal}
            onHide={props.modalClose}
            backdrop="static"
            keyboard={false}
            centered
            size="md"
        >
            <Modal.Body>
                <div className={styles.modalCancelBtnDiv}>
                    <Button className={styles.modalCancelBtn} onClick={props.modalClose}>
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.5 4.5L4.5 13.5" stroke="#24859A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M4.5 4.5L13.5 13.5" stroke="#24859A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </Button>
                </div>
                <div className={styles.modalHeaderDiv}>
                    <span className={styles.modalHeader}>Extend Assessment</span>
                </div>
                <Col sm={12} className="">
                    <Container>
                        <p className={styles.stepSubtopicName}>
                            {
                                step === 1 ? 'Assessment Configuration'
                                    : 'Review'
                            }
                        </p>
                    </Container>
                </Col>
                {step === 1 && <div>
                    <Col className={styles.alertColumn}>
                        <Container>
                            <CustomAlertBox
                                alertBodyText="Extend the external assessment expiration date. Once you extend the expiration date candidate will receive an email including a new submission link with assessment details."
                                alertType="defaultAlert"
                            />
                        </Container>
                    </Col>
                    <Col>


                        <Container className='mb-3  '>
                            <Formik
                                validationSchema={schema}
                                onSubmit={(values) => { nextPage(values) }}
                                initialValues={{ noOfExtendingDates: extendingTime }}>
                                {({
                                    values,
                                    errors,
                                    setFieldValue,
                                    handleChange,
                                    handleSubmit,
                                    submitCount
                                }) => (
                                    <Form noValidate onSubmit={handleSubmit}>

                                        <Form.Group>
                                            <div>
                                                <p className={styles.defaultLabel}>Extend Assessment Expire Date&nbsp;

                                                </p>
                                            </div>

                                            <div >
                                                <Row className={styles.toggleContainer}>
                                                    <Col>
                                                        <CustomTextField
                                                            //label="Short Description about Review Criteria"
                                                            //labelToolTip="The minimum score that candidates should receive in order to pass from this evaluation stage. Enter a percentage value."
                                                            //labelToolTipId="minimumPassScore"
                                                            name="noOfExtendingDates"
                                                            placeholder="ex:- 5"
                                                            classLabel="defaultLabel"
                                                            controlId="noOfExtendingDates"
                                                            type="number"
                                                            value={values.noOfExtendingDates}
                                                            classType="defaultTextBox"
                                                            handleOnChange={handleChange}
                                                            errorMessage={errors.noOfExtendingDates}
                                                            isInvalid={submitCount > 0 && !!errors.noOfExtendingDates}
                                                        />



                                                    </Col>
                                                    <Col lg={1} className='mt-2 mr-3'>

                                                        <p className={styles.defaultLabel}>Days</p>


                                                    </Col>
                                                </Row>
                                                <Row className={styles.actionBtns}>
                                                    <Col className="pl-0">
                                                        {<CustomButton
                                                            buttonType="submit"
                                                            label="Cancel"
                                                            type="defaultBtn"
                                                            handleClick={() => props.modalClose()}

                                                        />}
                                                    </Col>
                                                    <Col className="pr-0">
                                                        {<CustomButton
                                                            buttonType="submit"
                                                            label="Review"
                                                            type="primaryBtn"
                                                        // disabled={state === true ? true : false}
                                                        // backicon={
                                                        //     state === true ? (<i className="fas fa-circle-notch fa-spin"></i>)
                                                        //         : ''
                                                        // }
                                                        // handleClick={() => submitDetails()}
                                                        />}
                                                    </Col>
                                                </Row>


                                            </div>
                                        </Form.Group>
                                    </Form>
                                )}
                            </Formik>


                        </Container>
                    </Col>
                </div>}
                {
                    step == 2 &&
                    <Col>
                        <Container>
                            <Row className='mt-4 mb-3'>
                                <Col lg={4}>
                                    <p className={styles.defaultLabel}>Current Deadline &nbsp; :

                                    </p>
                                </Col>
                                <Col >
                                    <p className={styles.defaultLabel}>
                                        {moment(props.assessmentData.to_be_expired_at).utc().format('MMMM Do YYYY, h:mm A')}

                                    </p>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={4}>
                                    <p className={styles.defaultLabel}>New Deadline &nbsp; :

                                    </p>
                                </Col>
                                <Col>
                                    <p className={styles.defaultLabel}>
                                        {moment(newDeadline).utc().format('MMMM Do YYYY, h:mm A')}

                                    </p>
                                </Col>
                            </Row>
                            <Row className={styles.actionBtns}>
                                <Col className="pl-0">
                                    {<CustomButton
                                        buttonType="submit"
                                        label="Back"
                                        type="defaultBtn"
                                        handleClick={() => setStep(1)}

                                    />}
                                </Col>
                                <Col className="pr-0">
                                    {<CustomButton
                                        buttonType="submit"
                                        label="Submit"
                                        type="primaryBtn"
                                        disabled={isLoading === true ? true : false}
                                        backicon={
                                            isLoading === true ? (<i className="fas fa-circle-notch fa-spin"></i>)
                                                : ''
                                        }
                                        handleClick={() => onSubmit()}
                                    />}
                                </Col>
                            </Row>
                        </Container>
                    </Col>
                }
            </Modal.Body>
        </Modal>
    )
}

export default ExtendAssessmentTimeModal